/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DependencyMode } from 'src/app/app-data/models/Dependencies';
import { TicketEditService } from 'src/app/modules/ticket-edit/ticket-edit.service';
import { takeUntil } from 'rxjs/operators';
import { ActualPhase } from '@touchplan/common';

import * as strings from '@touchplan/strings';
import { EditTicketsCombined } from 'src/app/app-data/models/EditTicketsCombined';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';
import { DefaultLoggerService, ILoggerService } from '@touchplan/logging';

/** Example of angular observable input handling
alternatives:
	- use async with safe traversal: *ngIf="(mode | async)?.target"
	- use async with ngIf as variable: *ngIf="(mode | async) as syncMode; syncMode && syncMode.target"
	- use internal subscription:
	```
	js
	constructor{private cd: ChangeDetectorRef}
	mode.subscribe(m => { this.modeSync = m; this.cd.detectChanges() }) //also consider this.cd.markForCheck()
	html
	*ngIf="modeSync && modeSync.target"
	```
*/

@Component({
	selector: 'dependency-prompt',
	templateUrl: './dependency-prompt.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [LoggerServiceFactory.provide('DependencyPromptComponent')],
})
export class DependencyPromptComponent implements OnInit, OnDestroy {
	public static oldAngularName = 'dependencyPrompt';
	public strings = strings;
	// @ViewChild('multiSelectWrapper') multiSelectWrapper:ElementRef;
	@Input() public mode: Observable<DependencyMode>;
	public modeSync?: DependencyMode;

	@Output() public onSelectAll = new EventEmitter<boolean>();
	@Output() public onExit = new EventEmitter<boolean>();

	protected _hidden$: Subject<boolean> = new Subject();
	private shutdownSubject: Subject<boolean> = new Subject();

	constructor(private editService: TicketEditService, private logger: DefaultLoggerService) {}

	public exit() {
		this.onExit.emit(true);
	}
	public toggleSelectAll() {
		this.onSelectAll.emit(true);
	}

	public ngOnInit() {
		// this.mode.subscribe(m => {
		// 	this.logger.log('mode subbed', m);
		// 	this.modeSync = m;
		// 	this.cd.markForCheck()
		// })
		// MOC-3265
		this.editService.combinedEdit$
			.pipe(takeUntil(this.shutdownSubject))
			.subscribe((thing: EditTicketsCombined) => {
				if (
					thing &&
					(thing.data.actualPhase === ActualPhase.actualizing ||
						thing.data.actualPhase === ActualPhase.actualized)
				) {
					this._hidden$.next(true);
				}
			});
	}

	public ngOnDestroy() {
		this.shutdownSubject.next(true);
	}
}
